<script setup lang="ts">
import DeviceMap from '@/components/device/map/DeviceMap.vue';
import MapControlPanel from '@/components/_common/navbar/MapControlPanel.vue';
import SliderSearchTabsBar from '@/components/_common/SliderSearchTabsBar.vue';
import ThreeColumnLayout from "@/components/_common/ThreeColumnLayout.vue";
import GroupListView from '@/views/GroupListView.vue';
import DeviceListBar from '@/components/device/list/DeviceListBar.vue';
import TrackersTabs from '@/components/device/list/TrackersTabs.vue';

const typeId = 'groupsTabs';

import {useSynchronizedUrlQuerySearchStore} from "@/composables/useSynchronizedUrlQuerySearchStore";
useSynchronizedUrlQuerySearchStore();

import { useSynchronizedSidebars } from "@/composables/useSynchronizedSidebars";
useSynchronizedSidebars({ defaultOpenSidebar: 'right', persistScoutOpenState: true });

import {useSynchronizedSearchGroupList} from "@/composables/useSynchronizedSearchGroupList";
useSynchronizedSearchGroupList();

import {useSynchronizedSearchSlideBar} from "@/composables/useSynchronizedSearchSlideBar";
useSynchronizedSearchSlideBar(typeId);

import {useResetChatOnSidebarClose} from "@/composables/useResetChatOnSidebarClose";
useResetChatOnSidebarClose();

import {useResetChatOnAccountOrUserChange} from "@/composables/useResetChatOnAccountOrUserChange";
useResetChatOnAccountOrUserChange();
</script>


<template>
  <ThreeColumnLayout>
    <template #leftTop>
      <SliderSearchTabsBar :typeId="typeId" placeholder="Search Groups..." >
        <template #tabs>
          <TrackersTabs />
        </template>
      </SliderSearchTabsBar>
    </template>
    <template #left>
      <GroupListView />
    </template>
    <template #rightTop>
      <MapControlPanel>
        <template #filters>
          <DeviceListBar />
        </template>
      </MapControlPanel>
    </template>
    <template #right>
      <DeviceMap :view="`cluster`" :viewType="`groupList`" />
    </template>
  </ThreeColumnLayout>
</template>
